import React from "react";
import PropTypes from "prop-types";
import { Tooltipped } from "react-md";


class TippedIcon extends React.PureComponent {
    render() {
        return (
          <span onClick={this.props.onTooltipClicked}>
            <Tooltipped
              setPosition={true}
              label={this.props.tooltipText}
              position={this.props.tooltipPopoutDirection}
            >
              <span className="tipped-icon-tooltip-container">
                  <i className={`md-icon material-icons ${this.props.iconClassName}`}>{this.props.iconName}</i>
              </span>
            </Tooltipped>
          </span>
        );
    }
}

TippedIcon.defaultProps = {
    tooltipText: "No Tooltip Text Entered",
    iconName: "stop",
    iconClassName: "",
    tooltipPopoutDirection: "top",
    onTooltipClicked: null,
};

TippedIcon.propTypes = {
    tooltipText: PropTypes.string.isRequired,
    iconName: PropTypes.string.isRequired,
    iconClassName: PropTypes.string,
    tooltipPopoutDirection: PropTypes.string,
    onTooltipClicked: PropTypes.func,
};

export default TippedIcon;